import React from "react";
import { Check, Loader2 } from "lucide-react";

export default function EditToolbar({ onPublish, saving }) {
  return (
    <div className="fixed bottom-6 right-6 z-40">
      <button
        onClick={onPublish}
        disabled={saving}
        title="Publish Changes"
        className="flex items-center gap-2 px-5 py-3 bg-green-600 text-white rounded-full shadow-lg hover:bg-green-700 disabled:opacity-50 font-medium transition-colors"
      >
        {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <Check className="w-5 h-5" />}
        Publish Changes
      </button>
    </div>
  );
}